import { LogLevel } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_AZURE_AD_CLIENT_ID || '';
// Set to the customer tenant id for single-tenant app registrations; 'organizations' allows any work account.
const authorityTenant = process.env.REACT_APP_AZURE_AD_AUTHORITY_TENANT || 'organizations';
const apiScope = process.env.REACT_APP_API_SCOPE || `api://${clientId}/access_as_user`;

// MSAL configuration
export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${authorityTenant}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            // console.info(message);
            break;
          case LogLevel.Verbose:
            // console.debug(message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Login scopes — OpenID Connect basics for sign-in
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// The API scope must be exposed by the backend app registration so the token audience is the API, not Graph.
export const apiRequest = {
  scopes: [apiScope],
};
